import axios from "axios";
import { Dialog } from "vant";
const request = axios.create({
  // baseURL:process.env.NODE_ENV === "development" ? "/api" : "https://www.bjnfbk.com/",
  // baseURL: process.env.NODE_ENV === 'development' ? '/api' : ' https://jzt.dtfcloud.com/',
  baseURL:axios.defaults.baseURL = process.env.VUE_APP_API, // 测试 生产
  timeout: 60000
});
// axios.defaults.baseURL = process.env.VUE_APP_API; // 测试 生产
request.interceptors.response.use(
  function({ data }) {
    return data;
  },
  function(error) {
    const {
      response: { data = {} }
    } = error;
    Dialog.alert({
      title: "温馨提示",
      message: data.message || "接口异常"
    });
    return Promise.reject(error);
  }
);

export default request;
